import { motion, useScroll, useTransform } from "motion/react";
import { ArrowUpRight, Globe, Music, Activity } from "lucide-react";
import React, { useRef, useState, useEffect } from "react";
import { Link, useLocation, useOutletContext, useNavigate } from "react-router-dom";
import { MarqueeBanner } from "../components/MarqueeBanner";
import { TacitonicRadio } from "../components/TacitonicRadio";
import { AnimatedDivider } from "../components/AnimatedDivider";
import { DotPattern } from "../components/DotPattern";
import { SplitFlapDisplay } from "../components/SplitFlapDisplay";
import { Helmet } from "react-helmet-async";
import { LabelLogos } from "../components/LabelLogos";
import { buildCloudflareSrcSet, handleCloudflareImgError } from "../utils/cloudflareImage";

const LABEL_LOGOS = [
  { name: "300 Elektra Entertainment", url: "https://media.tacitonic.com/label-logos/300_Elektra_Entertainment_logo.svg?v=7" },
  { name: "300 Entertainment", url: "https://media.tacitonic.com/label-logos/300_Entertainment_logo.svg?v=7" },
  { name: "A&M Records", url: "https://media.tacitonic.com/label-logos/A&M_Records_logo.svg?v=7" },
  { name: "AWAL", url: "https://media.tacitonic.com/label-logos/AWAL_logo.svg?v=7" },
  { name: "Apple Music", url: "https://media.tacitonic.com/label-logos/Apple_Music_logo.svg?v=7" },
  { name: "Arista Records", url: "https://media.tacitonic.com/label-logos/Arista_Records_Logo.svg?v=7" },
  { name: "Atlantic Records", url: "https://media.tacitonic.com/label-logos/Atlantic_Records_logo.svg?v=7" },
  { name: "BMG", url: "https://media.tacitonic.com/label-logos/BMG_logo.svg?v=7" },
  { name: "Big Hit Music", url: "https://media.tacitonic.com/label-logos/Big_Hit_Music_logo.svg?v=7" },
  { name: "Blue Note Records", url: "https://media.tacitonic.com/label-logos/Blue_Note_Records_logo.svg?v=7" },
  { name: "Capitol Nashville Records", url: "https://media.tacitonic.com/label-logos/Capitol_Nashville_Records_logo.svg?v=7" },
  { name: "Capitol Records", url: "https://media.tacitonic.com/label-logos/Capitol_Records_logo.svg?v=7" },
  { name: "Columbia Records", url: "https://media.tacitonic.com/label-logos/Columbia_Records_logo.svg?v=7" },
  { name: "Concord", url: "https://media.tacitonic.com/label-logos/Concord_logo.svg?v=7" },
  { name: "Decca Records", url: "https://media.tacitonic.com/label-logos/Decca_Records_logo.svg?v=7" },
  { name: "Def Jam Recordings", url: "https://media.tacitonic.com/label-logos/Def_Jam_Recordings_logo.svg?v=7" },
  { name: "Disney Music Group", url: "https://media.tacitonic.com/label-logos/Disney_Music_Group_logo.svg?v=7" },
  { name: "Downtown Music Holdings", url: "https://media.tacitonic.com/label-logos/Downtown_Music_Holdings_logo.svg?v=7" },
  { name: "EMI Records", url: "https://media.tacitonic.com/label-logos/EMI_Records_logo.svg?v=7" },
  { name: "Elektra Records", url: "https://media.tacitonic.com/label-logos/Elektra_Records_logo.svg?v=7" },
  { name: "Empire Distribution", url: "https://media.tacitonic.com/label-logos/Empire_Distribution_logo.svg?v=7" },
  { name: "Epic Records", url: "https://media.tacitonic.com/label-logos/Epic_Records_logo.svg?v=7" },
  { name: "FIFA", url: "https://media.tacitonic.com/label-logos/FIFA_logo.svg?v=7" },
  { name: "Geffen Records", url: "https://media.tacitonic.com/label-logos/Geffen_Records_logo.svg?v=7" },
  { name: "Hybe Labels", url: "https://media.tacitonic.com/label-logos/Hybe_Labels_logo.svg?v=7" },
  { name: "Interscope Geffen A&M", url: "https://media.tacitonic.com/label-logos/Interscope_Geffen_A&M_logo.svg?v=7" },
  { name: "Interscope Records", url: "https://media.tacitonic.com/label-logos/Interscope_Records_logo.svg?v=7" },
  { name: "Island Def Jam Recordings", url: "https://media.tacitonic.com/label-logos/Island_Def_Jam_Recordings_logo.svg?v=7" },
  { name: "Island Records", url: "https://media.tacitonic.com/label-logos/Island_Records_logo.svg?v=7" },
  { name: "JYP Entertainment", url: "https://media.tacitonic.com/label-logos/JYP_Entertainment_logo.svg?v=7" },
  { name: "Kobalt", url: "https://media.tacitonic.com/label-logos/Kobalt_logo.svg?v=7" },
  { name: "MCA", url: "https://media.tacitonic.com/label-logos/MCA_logo.svg?v=7" },
  { name: "Mercury Records", url: "https://media.tacitonic.com/label-logos/Mercury_Records_logo.svg?v=7" },
  { name: "Mom + Pop", url: "https://media.tacitonic.com/label-logos/Mom_+_Pop_logo.png?v=7" },
  { name: "Motown", url: "https://media.tacitonic.com/label-logos/Motown_logo.svg?v=7" },
  { name: "Netflix", url: "https://media.tacitonic.com/label-logos/Netflix_logo.svg?v=7" },
  { name: "Nonesuch", url: "https://media.tacitonic.com/label-logos/Nonesuch_logo.png?v=7" },
  { name: "Partisan Records", url: "https://media.tacitonic.com/label-logos/Partisan_Records_logo.png?v=7" },
  { name: "Polydor", url: "https://media.tacitonic.com/label-logos/Polydor_logo.svg?v=7" },
  { name: "RCA Records", url: "https://media.tacitonic.com/label-logos/RCA_Records_logo.svg?v=7" },
  { name: "Republic Records", url: "https://media.tacitonic.com/label-logos/Republic_Records_logo.svg?v=7" },
  { name: "Reservoir Media", url: "https://media.tacitonic.com/label-logos/Reservoir_Media_logo.svg?v=7" },
  { name: "Rhino Entertainment", url: "https://media.tacitonic.com/label-logos/Rhino_Entertainment_logo.svg?v=7" },
  { name: "Riot Games", url: "https://media.tacitonic.com/label-logos/Riot_Games_logo.svg?v=7" },
  { name: "Roadrunner Records", url: "https://media.tacitonic.com/label-logos/Roadrunner_Records_logo.svg?v=7" },
  { name: "Rockstar Games", url: "https://media.tacitonic.com/label-logos/Rockstar_Games_logo.svg?v=7" },
  { name: "SM Entertainment", url: "https://media.tacitonic.com/label-logos/SM_Entertainment_logo.svg?v=7" },
  { name: "Sony Music Entertainment", url: "https://media.tacitonic.com/label-logos/Sony_Music_Entertainment_logo.svg?v=7" },
  { name: "Sony Music Japan", url: "https://media.tacitonic.com/label-logos/Sony_Music_Japan_logo.svg?v=7" },
  { name: "Spotify", url: "https://media.tacitonic.com/label-logos/Spotify_logo.svg?v=7" },
  { name: "T series", url: "https://media.tacitonic.com/label-logos/T-series-logo.svg?v=7" },
  { name: "The Black Label", url: "https://media.tacitonic.com/label-logos/The_Black_Label_logo.svg?v=7" },
  { name: "The Orchard", url: "https://media.tacitonic.com/label-logos/The_Orchard_logo.svg?v=7" },
  { name: "Universal Music Group", url: "https://media.tacitonic.com/label-logos/Universal_Music_Group_logo.svg?v=7" },
  { name: "Verve", url: "https://media.tacitonic.com/label-logos/Verve_logo.svg?v=7" },
  { name: "Virgin Records", url: "https://media.tacitonic.com/label-logos/Virgin_Records_logo.svg?v=7" },
  { name: "Warner Chappell Music", url: "https://media.tacitonic.com/label-logos/Warner_Chappell_Music_logo.svg?v=7" },
  { name: "Warner Music Global", url: "https://media.tacitonic.com/label-logos/Warner_Music_logo.svg?v=7" },
  { name: "YG Entertainment", url: "https://media.tacitonic.com/label-logos/YG_Entertainment_logo.svg?v=7" },
  { name: "Zee Music Company", url: "https://media.tacitonic.com/label-logos/Zee_Music_Company_logo.svg?v=7" }
];
import { Footer } from "../components/Footer";
import { TextScramble } from "../components/TextScramble";
import { MagneticButton } from "../components/MagneticButton";

import { ScrollShadow } from "../components/ScrollShadow";

export function Home() {
  const location = useLocation();
  const navigate = useNavigate();
  const { isFromMobile, hasLoaded } = useOutletContext<{ isFromNav: boolean, isFromMobile: boolean, hasLoaded: boolean }>();

  const containerRef = useRef<HTMLDivElement>(null);
  const servicesRef = useRef<HTMLElement>(null);
  const [isHoveringName, setIsHoveringName] = useState(false);
  
  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ["start start", "end end"]
  });

  const { scrollYProgress: servicesScroll } = useScroll({
    target: servicesRef,
    offset: ["center center", "end start"]
  });

  const heroY = useTransform(scrollYProgress, [0, 0.2], [0, 60]);
  const heroOpacity = useTransform(scrollYProgress, [0, 0.2], [1, 0]);

  const servicesY = useTransform(servicesScroll, [0, 1], [0, 150]);
  const servicesOpacity = useTransform(servicesScroll, [0, 1], [1, 0]);

  // Restores the Morphing Header animation by matching scroll coordinates before traversing
  const handleLinkClick = (e: React.MouseEvent<HTMLAnchorElement>, path: string) => {
    e.preventDefault();
    if (window.scrollY > 5) {
      // Cinematically smooth scroll to top to mask the distance traveled
      window.scrollTo({ top: 0, behavior: 'smooth' });
      
      const checkScroll = setInterval(() => {
        // Trigger just before it visually halts to capture the momentum
        if (window.scrollY <= 20) {
          clearInterval(checkScroll);
          
          // Snap the final few pixels instantly to 0 so Framer Motion reads pure 0.00 coordinates
          window.scrollTo(0, 0); 
          
          // Wait a tiny frame amount for the browser repainting to process the snap
          setTimeout(() => {
            navigate(path, { state: { fromMobile: false, fromNav: true } });
          }, 30);
        }
      }, 20);

      // Failsafe in case smooth scrolling stops or is blocked
      setTimeout(() => {
        clearInterval(checkScroll);
        if (window.location.pathname === '/' || window.location.pathname === '') {
          window.scrollTo(0, 0);
          setTimeout(() => {
            navigate(path, { state: { fromMobile: false, fromNav: true } });
          }, 30);
        }
      }, 1000);
    } else {
      window.scrollTo(0, 0);
      setTimeout(() => {
        navigate(path, { state: { fromMobile: false, fromNav: true } });
      }, 20);
    }
  };

  return (
    <>
      <Helmet>
        <title>Atharva Dhekne • Mastering & Immersive Audio Engineer | tacitonic</title>
        <meta name="description" content="Audio Engineer & Producer based in NYC. Specializing in Stereo Mastering, Immersive Audio (Dolby Atmos, Sony Reality360, IAMF Eclipsa Audio), Restoration, & Production at Sterling Sound & Eventide Audio." />
        <meta name="robots" content="index, follow, max-image-preview:large" />
        <meta name="googlebot" content="index, follow, max-image-preview:large" />
        <link rel="canonical" href="https://tacitonic.com/" />
        <meta property="og:title" content="Atharva Dhekne • Mastering & Immersive Audio Engineer | tacitonic" />
        <meta property="og:description" content="Audio Engineer & Producer based in NYC. Specializing in Stereo Mastering, Immersive Audio, Restoration, & Production at Sterling Sound & Eventide Audio." />
        <meta property="og:url" content="https://tacitonic.com/" />
        <meta property="og:image" content="https://media.tacitonic.com/media/tacitonic-hero.webp?v=7" />
        <meta name="twitter:image" content="https://media.tacitonic.com/media/tacitonic-hero.webp?v=7" />
        <meta name="thumbnail" content="https://media.tacitonic.com/media/tacitonic-hero.webp?v=7" />
      </Helmet>
      <main ref={containerRef} className="relative bg-black">
      {/* Hero Background Image */}
      <motion.div 
        className="absolute top-0 left-0 w-full h-[100dvh] z-0 pointer-events-none overflow-hidden"
        initial={{ opacity: 0 }}
        animate={{ opacity: isHoveringName ? 0.5 : 0 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.5 }}
      >
        <img 
          src="https://media.tacitonic.com/cdn-cgi/image/width=1346,quality=70,format=auto/media/tacitonic-hero.webp?v=7" 
          srcSet="https://media.tacitonic.com/cdn-cgi/image/width=640,quality=70,format=auto/media/tacitonic-hero.webp?v=7 640w, https://media.tacitonic.com/cdn-cgi/image/width=960,quality=70,format=auto/media/tacitonic-hero.webp?v=7 960w, https://media.tacitonic.com/cdn-cgi/image/width=1346,quality=70,format=auto/media/tacitonic-hero.webp?v=7 1346w"
          sizes="100vw"
          width={1346}
          height={940}
          decoding="async"
          loading="lazy"
          alt="Atharva Dhekne, Audio Mastering and Immersive Engineer in his NYC recording studio" 
          className="w-full h-full object-cover object-[92%_20%] md:object-center grayscale" 
        />
      </motion.div>      

      {/* Hero Section Wrapper */}
      <div className="relative w-full z-0">
        {/* Hero Background Pattern */}
        <motion.div 
          className="absolute inset-0 z-0 overflow-hidden pointer-events-none"
          animate={{ opacity: isHoveringName ? 0 : 1 }}
          transition={{ duration: 0.5 }}
        >
          <DotPattern />
        </motion.div>

        {/* Hero Section */}
        <motion.section 
          className="relative z-10 pt-36 md:pt-[184px] pb-8 min-h-[72vh] lg:min-h-[82vh] flex flex-col justify-center px-6 max-w-7xl mx-auto"
        >
        <motion.div
          style={{ y: heroY, opacity: heroOpacity }}
          initial={hasLoaded ? { y: 0 } : { y: 10 }}
          animate={{ y: 0 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
          className="flex flex-col text-left"
        >
          <h1 className="text-[31px] md:text-[52px] lg:text-[64px] font-bold tracking-tighter uppercase mb-6 font-display flex flex-col gap-2">
            <motion.span
              initial={hasLoaded ? { opacity: 1, x: 0 } : { opacity: 0, x: -10 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6, ease: "easeOut" }}
              className="relative inline-block group cursor-none hover-target"
              onMouseEnter={() => setIsHoveringName(true)}
              onMouseLeave={() => setIsHoveringName(false)}
            >
              <span className="relative z-10 lg:group-hover:text-black transition-colors duration-500">Atharva Dhekne</span>
              <motion.span 
                className="absolute inset-0 bg-white scale-x-0 lg:group-hover:scale-x-100 transition-transform duration-500 origin-left"
                style={{ zIndex: 0 }}
              />
            </motion.span>
          <div className="overflow-hidden">
            <motion.span 
              initial={hasLoaded ? { y: 0 } : { y: "100%" }}
              animate={{ y: 0 }}
              transition={{ duration: 0.8, delay: hasLoaded ? 0 : 0.15, ease: [0.19, 1, 0.22, 1] }}
              className="text-white/40 text-base md:text-xl lg:text-2xl tracking-normal font-sans leading-none block"
            >
              <TextScramble text="[əˈtʰəˌɾʋə ɖʱeˑˌkə.ɳe]" />
            </motion.span>
          </div>
          <div className="overflow-hidden">
            <motion.span 
              initial={hasLoaded ? { y: 0 } : { y: "100%" }}
              animate={{ y: 0 }}
              transition={{ duration: 0.8, delay: hasLoaded ? 0 : 0.3, ease: [0.19, 1, 0.22, 1] }}
              className="text-2xl md:text-4xl lg:text-5xl tracking-normal lowercase font-responsive-bold font-sans leading-none block"
            >
              alias <span className="italic">tacitonic</span>
            </motion.span>
          </div>
        </h1>
        
        <motion.div 
          initial={hasLoaded ? { opacity: 1, y: 0 } : { opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: hasLoaded ? 0 : 0.4, ease: [0.19, 1, 0.22, 1] }}
          className="transition-opacity duration-500 opacity-100"
        >
          <div className="text-[18px] md:text-3xl font-responsive-bold tracking-tight opacity-80 max-w-4xl leading-relaxed mt-2 md:mt-8">
            Currently at Sterling Sound and Eventide Audio. <br />
            Based in New York, NY.
          </div>

          <div className="flex flex-wrap gap-1 md:gap-6 mt-8 md:mt-12 mb-8">
            <MagneticButton>
              <a href="/about" aria-label="About" onClick={(e) => handleLinkClick(e, '/about')} className="group flex items-center gap-2 md:gap-3 border-2 border-white/20 hover:border-transparent pl-5 pr-4 py-3 md:pl-8 md:pr-6 md:py-4 hover:bg-white hover:text-black transition-all duration-300 hover-target font-mono text-[10px] md:text-[12px] uppercase tracking-[0.2em] font-bold relative overflow-hidden">
                <span className="relative z-10"><TextScramble text="About" /></span> <ArrowUpRight className="text-[#9af104] opacity-100 transition-opacity relative z-10 w-3.5 h-3.5 md:w-4 md:h-4" />
              </a>
            </MagneticButton>
            <MagneticButton>
              <a href="/discography" aria-label="Discography" onClick={(e) => handleLinkClick(e, '/discography')} className="group flex items-center gap-2 md:gap-3 border-2 border-white/20 hover:border-transparent pl-5 pr-4 py-3 md:pl-8 md:pr-6 md:py-4 hover:bg-white hover:text-black transition-all duration-300 hover-target font-mono text-[10px] md:text-[12px] uppercase tracking-[0.2em] font-bold relative overflow-hidden">
                <span className="relative z-10"><TextScramble text="Discography" /></span> <ArrowUpRight className="text-[#9af104] opacity-100 transition-opacity relative z-10 w-3.5 h-3.5 md:w-4 md:h-4" />
              </a>
            </MagneticButton>
          </div>
        </motion.div>
        </motion.div>
      </motion.section>
      </div>

      <div className="transition-opacity duration-500 opacity-100">
        {/* Dynamic Marquees (Services) */}
        <div className="relative z-10">
          <MarqueeBanner text="Stereo Mastering • Immersive Mastering • Immersive Mixing • Production • Interactive Audio • Recording • Music Technology Consulting" />
        </div>

        {/* Philosophy Section */}
        <section className="relative py-32 px-6 max-w-7xl mx-auto">
          <ScrollShadow>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
              <div className="text-[31px] md:text-[52px] font-bold uppercase tracking-tighter font-display leading-[0.9]">
                <span className="block">Sonic</span>
                <span className="block italic text-white/70">Fidelity +</span>
                <span className="block">Creative</span>
                <span className="block italic text-white/50">Gradation +</span>
                <span className="block">Technical</span>
                <span className="block text-[#9af104]">Precision</span>
              </div>
              <div className="space-y-8">
                <p className="text-xl md:text-2xl opacity-80 leading-relaxed font-responsive-bold">
                  Navigating the complex intersection of art and technology to deliver music that translates flawlessly across critical listening environments and consumer playback systems.
                </p>
                <p className="text-lg opacity-60 leading-relaxed font-responsive-bold">
                  Drawing from collaborations with a distinguished collection of influential artists, every record worked on is informed by an extensive sonic vocabulary and a deep appreciation for creative expression. This multi-modal artistic identity transcends genre; allowing the project to expand its technical boundaries while preserving the integrity of the artist's original performance.
                </p>
              </div>
            </div>
          </ScrollShadow>
        </section>

        {/* Artists Banner */}
        <div className="relative z-10">
          <MarqueeBanner text="Keith Richards • David Guetta • Europe • The Black Keys • j-hope • Jin • Benny Blanco • MEOVV • Dua Lipa • AP Dhillon • Avadhoot Gupte • The Rolling Stones • Future • Tedeschi Trucks Band • Jelly Roll • Green Day • Tame Impala • Slayyyter • Turnstile • J. Cole • Kacey Musgraves • Shor Police • Poolside • Jisoo • Rauw Alejandro • Bebe Rexha • Diljit Dosanjh • Branford Marsalis • Miley Cyrus • Miranda Lambert • ENHYPEN • Dave Holland • Rvssian • Metro Boomin • JENNIE • Latto • Carlos Santana • Shawn Mendes • BigXThaPlug • Robyn • Young Nudy • Ava Max • Rihanna • Metric • Clinton Cerejo • Goo Goo Dolls • Selena Gomez • Bad Bunny • ROSÉ • Robbie Williams • ILLIT • Florence + The Machine • Twenty One Pilots • Central Cee • Josh Groban • Noah Kahan • LE SSERAFIM • Shubh • Lin-Manuel Miranda • Joan Jett • The National • keshi • KATSEYE • Glass Animals • Steve Aoki • Jimmy Webb • Paul Simon • Hermanos Gutiérrez • Andrea Bocelli • Pharrell Williams • Dinosaur Jr. • Tom Odell • Sam Fender • Bill Frisell • OneRepublic • Leon Bridges • Three Days Grace • MINNIE • Karan Aujla • Kate Hudson • Robert Cray • Balu Brigada • BLACKPINK • Maroon 5 • Laufey • Billy Joel • Don Toliver" reverse />
        </div>

        {/* Services / Approach Summary */}
        <motion.section 
          ref={servicesRef}
          id="services" 
          className="relative z-10 pt-12 lg:pt-24 pb-24 px-6 max-w-7xl mx-auto"
        >
          <ScrollShadow>
            <div className="flex flex-col md:flex-row justify-between items-start md:items-end mb-16 relative pb-4 md:pb-8 gap-6 md:gap-4">
              <h2 className="block text-[31px] md:text-[52px] lg:text-[64px] w-full md:w-auto text-left font-bold tracking-tighter uppercase leading-none font-display m-0">Global Reach</h2>
              
              <div className="w-full md:hidden">
                <AnimatedDivider className="h-[3px] bg-white" />
              </div>

              <MagneticButton>
                <a href="/services" aria-label="Services" onClick={(e) => handleLinkClick(e, '/services')} className="group flex items-center gap-2 md:gap-3 border-2 border-white/20 hover:border-transparent pl-5 pr-4 py-3 md:pl-8 md:pr-6 md:py-4 hover:bg-white hover:text-black transition-all duration-300 hover-target font-mono text-[10px] md:text-[12px] uppercase tracking-[0.2em] font-bold relative overflow-hidden">
                  <span className="relative z-10"><TextScramble text="Services" /></span> <ArrowUpRight className="text-[#9af104] opacity-100 transition-opacity relative z-10 w-3.5 h-3.5 md:w-4 md:h-4" />
                </a>
              </MagneticButton>
              <div className="hidden md:block absolute bottom-0 left-0 w-full">
                <AnimatedDivider className="h-[3px] bg-white" />
              </div>
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
              <div className="flex flex-col border-2 border-white/20 hover:border-white transition-all duration-300 p-4 md:p-8 group hover-target overflow-hidden">
                <div className="flex justify-between items-start mb-8 border-b-[3px] border-white pb-4 gap-4">
                  <h3 className="text-[20px] md:text-[25px] font-bold uppercase tracking-tight font-display pr-8 flex-1 min-w-0">International Standards</h3>
                  <Globe className="opacity-40 group-hover:opacity-100 transition-opacity shrink-0 mt-1" size={32} />
                </div>
                <p className="text-base md:text-lg opacity-80 leading-relaxed font-responsive-bold">
                  Adhering to the highest industry standards and deliverable specifications for all global major labels.
                </p>
              </div>
              <div className="flex flex-col border-2 border-white/20 hover:border-white transition-all duration-300 p-4 md:p-8 group hover-target overflow-hidden">
                <div className="flex justify-between items-start mb-8 border-b-[3px] border-white pb-4 gap-4">
                  <h3 className="text-[20px] md:text-[25px] font-bold uppercase tracking-tight font-display pr-8 flex-1 min-w-0">Cultural Nuance</h3>
                  <Music className="opacity-40 group-hover:opacity-100 transition-opacity shrink-0 mt-1" size={32} />
                </div>
                <p className="text-base md:text-lg opacity-80 leading-relaxed font-responsive-bold">
                  Strategic partnerships and deep contextual insight of highly diverse global music landscapes, seamlessly transitioning between genres.
                </p>
              </div>
              <div className="flex flex-col border-2 border-white/20 hover:border-white transition-all duration-300 p-4 md:p-8 group hover-target overflow-hidden">
                <div className="flex justify-between items-start mb-8 border-b-[3px] border-white pb-4 gap-4">
                  <h3 className="text-[20px] md:text-[25px] font-bold uppercase tracking-tight font-display pr-8 flex-1 min-w-0">Technical Expertise</h3>
                  <Activity className="opacity-40 group-hover:opacity-100 transition-opacity shrink-0 mt-1" size={32} />
                </div>
                <p className="text-base md:text-lg opacity-80 leading-relaxed font-responsive-bold">
                  Leveraging industry-leading apparatus and critical listening to deliver the benchmark of audio mastering.
                </p>
              </div>
            </div>
          </ScrollShadow>
        </motion.section>

        {/* Formats Section */}
        <section className="relative z-10 py-12 px-6 max-w-7xl mx-auto">
          <ScrollShadow>
            <div className="relative pb-8 mb-12">
              <h2 className="text-[25px] md:text-[40px] font-bold uppercase tracking-tighter font-display">Formats</h2>
              <div className="absolute bottom-0 left-0 w-full">
                <AnimatedDivider className="h-[3px] bg-white" />
              </div>
            </div>
            <div className="grid grid-cols-2 gap-2 md:flex md:flex-wrap md:gap-4">
              {["Lossless Digital", "Compact Disc (CD)", "Vinyl", "Analog Tape", "Cassette", "Apple Digital Masters", "Dolby Atmos", "Sony 360 Reality Audio", "Eclipsa Audio"].map(format => (
                <div key={format} className="border-2 border-white/20 pl-5 pr-4 py-3 md:px-6 md:py-3 font-mono text-[10px] md:text-base uppercase tracking-widest transition-colors cursor-none text-center flex items-center justify-center font-bold">
                  {format}
                </div>
              ))}
            </div>
            <div className="flex flex-wrap items-center gap-8 md:gap-12 mt-12 pt-4" data-nosnippet>
              <img
                src="https://media.tacitonic.com/media/Apple-Lossless-logo.svg"
                alt="Apple Lossless"
                width={150}
                height={90}
                loading="lazy"
                decoding="async"
                className="h-8 md:h-11 w-auto object-contain brightness-0 invert opacity-90 hover:opacity-100 transition-opacity"
              />
              <img
                src="https://media.tacitonic.com/media/Compact-Disc-logo.svg"
                alt="Compact Disc Digital Audio"
                width={437}
                height={268}
                loading="lazy"
                decoding="async"
                className="h-7 md:h-10 w-auto object-contain brightness-0 invert opacity-90 hover:opacity-100 transition-opacity"
              />
              <img
                src="https://media.tacitonic.com/media/LP-logo.svg#svgView(viewBox(0,0,230,230))"
                alt="LP Vinyl"
                width={230}
                height={230}
                loading="lazy"
                decoding="async"
                className="h-8 md:h-11 w-auto object-contain brightness-0 invert opacity-90 hover:opacity-100 transition-opacity"
              />
              <img
                src="https://media.tacitonic.com/media/Compact-Cassette-logo.svg"
                alt="Compact Cassette"
                width={1452}
                height={444}
                loading="lazy"
                decoding="async"
                className="h-7 md:h-10 w-auto object-contain brightness-0 invert opacity-90 hover:opacity-100 transition-opacity"
              />
              <img
                src="https://media.tacitonic.com/cdn-cgi/image/width=213,quality=80,format=webp/media/Apple-Digital-Masters-logo.webp"
                srcSet="https://media.tacitonic.com/cdn-cgi/image/width=213,quality=80,format=webp/media/Apple-Digital-Masters-logo.webp 1x, https://media.tacitonic.com/cdn-cgi/image/width=426,quality=80,format=webp/media/Apple-Digital-Masters-logo.webp 2x"
                alt="Apple Digital Masters"
                width={213}
                height={64}
                loading="lazy"
                decoding="async"
                className="h-12 md:h-16 w-auto object-contain opacity-90 hover:opacity-100 transition-opacity"
              />
              <img
                src="https://media.tacitonic.com/cdn-cgi/image/width=130,quality=80,format=webp/media/Dolby-Atmos-Vertical-logo.webp"
                srcSet="https://media.tacitonic.com/cdn-cgi/image/width=130,quality=80,format=webp/media/Dolby-Atmos-Vertical-logo.webp 1x, https://media.tacitonic.com/cdn-cgi/image/width=260,quality=80,format=webp/media/Dolby-Atmos-Vertical-logo.webp 2x"
                alt="Dolby Atmos"
                width={130}
                height={48}
                loading="lazy"
                decoding="async"
                className="h-9 md:h-12 w-auto object-contain brightness-0 invert opacity-90 hover:opacity-100 transition-opacity"
              />
              <img
                src="https://media.tacitonic.com/cdn-cgi/image/width=142,quality=80,format=webp/media/360RA-logo.webp"
                srcSet="https://media.tacitonic.com/cdn-cgi/image/width=142,quality=80,format=webp/media/360RA-logo.webp 1x, https://media.tacitonic.com/cdn-cgi/image/width=284,quality=80,format=webp/media/360RA-logo.webp 2x"
                alt="Sony 360 Reality Audio"
                width={142}
                height={80}
                loading="lazy"
                decoding="async"
                className="h-14 md:h-20 w-auto object-contain opacity-90 hover:opacity-100 transition-opacity"
              />
              <img
                src="https://media.tacitonic.com/cdn-cgi/image/width=204,quality=80,format=webp/media/Eclipsa-Audio-logo.webp"
                srcSet="https://media.tacitonic.com/cdn-cgi/image/width=204,quality=80,format=webp/media/Eclipsa-Audio-logo.webp 1x, https://media.tacitonic.com/cdn-cgi/image/width=408,quality=80,format=webp/media/Eclipsa-Audio-logo.webp 2x"
                alt="Eclipsa Audio"
                width={204}
                height={40}
                loading="lazy"
                decoding="async"
                className="h-7 md:h-10 w-auto object-contain invert opacity-90 hover:opacity-100 transition-opacity"
              />
            </div>
          </ScrollShadow>
        </section>

        {/* Stats Section */}
        <section className="relative z-10 bg-black text-white pt-32 pb-0">
          <div className="px-6">
            <ScrollShadow className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-12 text-center mb-24">
              <div className="space-y-2">
                <div className="text-[13vw] md:text-6xl lg:text-8xl font-bold font-mono tracking-tighter"><SplitFlapDisplay text="10B+" /></div>
                <div className="text-sm font-mono uppercase tracking-widest font-bold opacity-80">Total Streams</div>
              </div>
              <div className="space-y-2">
                <div className="text-[13vw] md:text-6xl lg:text-8xl font-bold font-mono tracking-tighter"><SplitFlapDisplay text="700+" /></div>
                <div className="text-sm font-mono uppercase tracking-widest font-bold opacity-80">Chart Topping Hits</div>
              </div>
              <div className="space-y-2">
                <div className="text-[13vw] md:text-6xl lg:text-8xl font-bold font-mono tracking-tighter"><SplitFlapDisplay text="60+" /></div>
                <div className="text-sm font-mono uppercase tracking-widest font-bold opacity-80">Global Labels</div>
              </div>
            </ScrollShadow>
          </div>
        </section>

        {/* Labels Banner - Moved outside and made flush */}
        <div className="relative z-20">
          <MarqueeBanner items={LABEL_LOGOS.map((label) => <LabelLogos key={label.name} name={label.name} url={label.url} />)} />
        </div>

        {/* Contact Section */}
        <Footer />
      </div>
    </main>
    </>
  );
}
